export class BasePayment {
  constructor(intInstallments = 1) {
    this.intInstallments = intInstallments
  }
}


export class TokenCCPayment extends BasePayment {
  constructor(object) {
    super(object["intInstallments"] || 1)
    this.cdCcToken = object["cdCcToken"] || null
    this.strCcBrand = object["strCcBrand"] || null
    this.blCcSave = object["blCcSave"] || true
  }
}
